import { render } from "./GoBackButton.vue?vue&type=template&id=586277e7&scoped=true"
import script from "./GoBackButton.vue?vue&type=script&lang=js"
export * from "./GoBackButton.vue?vue&type=script&lang=js"

import "./GoBackButton.vue?vue&type=style&index=0&id=586277e7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-586277e7"]])

export default __exports__